import http, {download} from "../../../utils/HttpUtils";

//库存统计
class StockStatisticService {
    //分页查询库存信息信息
    static async findPage(data) {
        const apiUrl = "/stock/statistic/findPage";
        return await http.post(apiUrl, data);
    }


    //导出库存
    static async exportStock(data) {
        const apiUrl = "/stock/statistic/export";
        await download(apiUrl, {type: "POST", data})
    }

    //移库
    static async shift(data) {
        const apiUrl = "/stock/statistic/shift";
        return await http.post(apiUrl, data);
    }

    //分页查询特定商品的进销存明细
    static async findMaterialPSS(data) {
        const apiUrl = "/stock/statistic/findMaterialPSS";
        return await http.post(apiUrl, data);
    }

    //是否积压库存
    static async isoverstock(id,isBacklog){
        const apiUrl = `base/material/isBacklog/${id}/${isBacklog}`;
        return await http.get(apiUrl);
    }
}

export default StockStatisticService;
